"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var styles_1 = require("@mui/material/styles");
var Card_1 = require("@mui/material/Card");
var CardMedia_1 = require("@mui/material/CardMedia");
var CardContent_1 = require("@mui/material/CardContent");
var Typography_1 = require("@mui/material/Typography");
var IconButton_1 = require("@mui/material/IconButton");
var Delete_1 = require("@mui/icons-material/Delete");
var Edit_1 = require("@mui/icons-material/Edit");
var GenericModal_1 = require("./GenericModal");
var Sponsor_1 = require("../models/Sponsor");
var Role_1 = require("../shared/utilities/Role");
var useRef = React.useRef;
var StyledCard = styles_1.styled(Card_1.default)({
    color: 'darkslategray',
    backgroundColor: '#F3F3F3',
    marginBottom: 8,
    borderRadius: 4,
    width: '100%'
});
var ImageStyleLeft = {
    maxHeight: '33vh',
    maxWidth: '33vw',
    width: 'auto',
    height: 'auto',
    float: 'left',
    padding: '10px'
};
var ImageStyleRight = {
    maxHeight: '33vh',
    maxWidth: '33vw',
    width: 'auto',
    height: 'auto',
    float: 'right',
    padding: '10px'
};
var DrawerHeader = styles_1.styled("div")(function (_a) {
    var theme = _a.theme;
    return (__assign({ display: "flex", alignItems: "center", justifyContent: "flex-end", padding: theme.spacing(0, 1) }, theme.mixins.toolbar));
});
function Sponsor(props) {
    var role = Role_1.default();
    var _a = React.useState(props.side), side = _a[0], setSide = _a[1];
    var deleteModalRef = useRef(null);
    return (React.createElement(React.Fragment, null,
        React.createElement(StyledCard, null,
            React.createElement(CardContent_1.default, null,
                role === 'Admin' &&
                    React.createElement(IconButton_1.default, { edge: "end", "aria-label": "comments", style: side == 'right' ? { float: 'left' } : { float: 'right' }, onClick: function () {
                            var _a;
                            deleteModalRef && ((_a = deleteModalRef === null || deleteModalRef === void 0 ? void 0 : deleteModalRef.current) === null || _a === void 0 ? void 0 : _a.handleOpen());
                        } },
                        React.createElement(Delete_1.default, null)),
                role === 'Admin' &&
                    React.createElement(IconButton_1.default, { edge: "end", "aria-label": "comments", style: side == 'right' ? { float: 'left' } : { float: 'right' }, onClick: function () {
                            var sponsor = new Sponsor_1.SponsorModel();
                            sponsor.SponsorName = props.name;
                            sponsor.SponsorDescription = props.body;
                            sponsor.SponsorEmail = props.email;
                            sponsor.SponsorId = props.id;
                            sponsor.SponsorLogoLocation = props.logoLocation;
                            sponsor.SponsorPhoneNumber = props.phoneNumber;
                            sponsor.SponsorWebsite = props.website;
                            props.openSponsorModal(sponsor);
                        } },
                        React.createElement(Edit_1.default, null)),
                React.createElement(Typography_1.default, { variant: "h5", align: "center" }, props.name),
                React.createElement(CardMedia_1.default, { component: "img", image: props.logoLocation, style: side == 'right' ? ImageStyleRight : ImageStyleLeft }),
                React.createElement(Typography_1.default, { variant: "body2", component: "pre", style: { whiteSpace: 'pre-wrap', wordWrap: 'break-word', marginTop: '10px' } }, props.body),
                React.createElement(Typography_1.default, { variant: "body2", paddingTop: "10px" }, props.phoneNumber != null && props.phoneNumber.length > 0 &&
                    React.createElement("div", null,
                        "Phone Number: ",
                        props.phoneNumber)),
                React.createElement(Typography_1.default, { variant: "body2" }, props.email != null && props.email.length > 0 &&
                    React.createElement("div", null,
                        "Email: ",
                        props.email)),
                React.createElement(Typography_1.default, { variant: "body2" }, props.website != null && props.website.length > 0 &&
                    React.createElement("div", null,
                        "Website: ",
                        props.website)))),
        React.createElement(GenericModal_1.default, { ref: deleteModalRef, text: 'Are you sure you want to delete sponsor ' + props.name + '?', action: props.delete, value: props.id })));
}
exports.default = Sponsor;
//# sourceMappingURL=Sponsor.js.map